import { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Sidebar } from '@/components/navigation/Sidebar';
import { TopNav } from '@/components/navigation/TopNav';

export function AppLayout(): React.JSX.Element {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  // The shell scrolls, not the window, so the browser's own scroll restoration never applies
  // here — opening a record from halfway down a list left the new page scrolled to the old
  // offset, below its heading. Keyed on pathname only, so filtering or paging a list (which
  // changes the query string, not the path) keeps the reader where they are.
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return (
    // h-full, not h-screen: 100vh ignores the horizontal scrollbar, so a wide page pushed the
    // shell past the usable height and the document scrolled too. #root is now 100% tall.
    <div className="flex h-full overflow-hidden">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      {/* `relative` makes this the containing block for absolutely positioned descendants.
          Without it they resolve against the document, and an `sr-only` element (position:
          absolute) sitting at the foot of a tall page stretched the document's scrollable
          area to match — putting a second scrollbar beside this one. */}
      <div ref={scrollRef} className="relative flex min-w-0 flex-1 flex-col overflow-y-auto">
        <TopNav onMenuClick={() => setMobileOpen(true)} />
        <main className="flex-1 p-4 sm:p-6" id="main-content">
          <Outlet />
        </main>
        <footer className="border-t py-4 text-center text-xs text-muted-foreground">
          © 2025 Health Camp Program. All rights reserved.
        </footer>
      </div>
    </div>
  );
}
